<div class="mapa-dialog">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

  <app-mapa
    [setVehicles]="vehicles"
    [setFocus]="focus"
    [setRoutePoints]="points"
    [setvehicleDetail]="true"
  ></app-mapa>

  <!-- Switch de pestañas -->
  <div class="tab-switch">
    <button class="tab-btn" [class.tab-btn--active]="activeTab === 'info'" (click)="activeTab = 'info'">
      Información del vehículo
    </button>
    <button style="margin-left: 10px;" class="tab-btn" [class.tab-btn--active]="activeTab === 'complementos'" (click)="activeTab = 'complementos'">
      Complementos instalados
    </button>
  </div>

  <!-- Pestaña: Información del vehículo -->
  <div class="mat-table-light" *ngIf="activeTab === 'info'">
    <div class="mat-row-light">
      <div class="mat-cell-light cell-padding"><b>Patente:</b> <span *ngIf="!isLoading">{{item.patente}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
      <div class="mat-cell-light cell-padding"><b>Descripción:</b> <span *ngIf="!isLoading">{{item.desc}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
      <div class="mat-cell-light cell-padding"><b>Velocidad:</b> <span *ngIf="!isLoading">{{item.sog}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
    </div>
    <div class="mat-row-light">
      <div class="mat-cell-light cell-padding"><b>Satelites:</b> <span *ngIf="!isLoading">{{item.nsat}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
      <div class="mat-cell-light cell-padding"><b>Orientación:</b> <span *ngIf="!isLoading">{{item.cog}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
      <div class="mat-cell-light cell-padding"><b>Alimentación:</b> <span *ngIf="!isLoading">{{alimentacion}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
    </div>
    <div class="mat-row-light">
      <div class="mat-cell-light cell-padding"><b>Ignición:</b> <span>{{ignicion}}</span></div>
      <div class="mat-cell-light cell-padding"><b>Fecha GPS:</b> <span> {{fechaGPS | date: 'HH:mm:ss dd/MM/yyyy'}}</span></div>
      <div class="mat-cell-light cell-padding"><b>Hora Registro:</b> <span> {{fechaRegistro | date: 'HH:mm:ss dd/MM/yyyy'}}</span>
      </div>
    </div>
    <div class="mat-row-light">
      <div class="mat-cell-light cell-padding"><b>Horometro:</b> <span *ngIf="!isLoading">{{horometro}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span></div>
      <div class="mat-cell-light cell-padding"><b>Odómetro:</b> <span *ngIf="!isLoading">{{odometro}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span></div>
      <div class="mat-cell-light cell-padding center-content">
        <em class="material-icons">
          person
        </em><b>Conductor:</b>
        <span *ngIf="!isLoading" class="break">
                {{conductor}}
              </span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
    </div>
    <div class="mat-row-light">
      <div class="mat-cell-light cell-padding center-content">
        <em class="material-icons">
          place
        </em><b>Dirección:</b>
        <span *ngIf="isDireccion" class="break">
              {{item !== undefined ? item.direccion : ''}}
              </span>
        <span *ngIf="!isDireccion">{{noDisponible}}</span>
      </div>
    </div>
    <div class="mat-row-light" *ngIf="bateriaGPS != null">
      <div class="mat-cell-light cell-padding"><b>Bateria GPS:</b> <span *ngIf="!isLoading">{{bateriaGPS}}</span>
        <span *ngIf="isLoading">{{noDisponible}}</span>
      </div>
    </div>
  </div>

  <!-- Pestaña: Complementos instalados -->
  <div class="mat-table-light" *ngIf="activeTab === 'complementos'">
    <div *ngIf="isLoading" class="no-complementos">{{noDisponible}}</div>
    <ng-container *ngIf="!isLoading">
      <div *ngIf="!hasComplementos" class="mat-row-light no-complementos">
        Este vehículo no cuenta con complementos instalados
      </div>
      <ng-container *ngIf="hasComplementos">
        <div class="mat-row-light" *ngFor="let row of complementoRows">
          <div class="mat-cell-light cell-padding" *ngFor="let col of row">
            <b>{{col.label}}:</b> <span>{{col.value}}</span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<div align="center">
  <button mat-flat-button (click)="close()">Cerrar</button>
  <button mat-flat-button class="btn-historial" (click)="verHistorial()">Ver Historial</button>
</div>
